<template>
  <div class="container page lottery-record-page">
    <van-nav-bar :title="pageTitle" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#111111" @click="back" />
      </template>
    </van-nav-bar>

    <div class="record-body">
      <div v-if="records.length" class="record-list">
        <section v-for="(item, index) in records" :key="`${item.expect}-${index}`" class="record-card">
          <div class="record-top">
            <span class="record-expect">{{ item.expect }}</span>
            <span class="record-name">{{ getLotteryName(item) }}</span>
          </div>

          <div class="record-types">{{ formatBetTypes(item) }}</div>

          <div class="record-amount">
            <span class="amount-label">{{ amountLabel }}</span>
            <span class="amount-value">{{ item.money }}</span>
          </div>

          <div class="record-time">{{ orderTimeLabel }}: {{ item.create_time || "--" }}</div>
          <div class="record-time">{{ settleTimeLabel }}: {{ item.update_time || "--" }}</div>
        </section>
      </div>

      <van-empty v-else :description="emptyText" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      currentLotteryId: this.$route.query.id || "",
    };
  },
  computed: {
    pageTitle() {
      const lang = this.$t("auth.lang");
      const titleMap = {
        zh: "投注记录",
        en: "Voting records",
        ja: "投票記録",
        kr: "투표 기록",
      };
      return titleMap[lang] || titleMap.zh;
    },
    emptyText() {
      const lang = this.$t("auth.lang");
      const textMap = {
        zh: "暂无记录",
        en: "No records",
        ja: "記録がありません",
        kr: "기록이 없습니다",
      };
      return textMap[lang] || textMap.zh;
    },
    amountLabel() {
      const lang = this.$t("auth.lang");
      const labelMap = {
        zh: "投注金额",
        en: "Bet amount",
        ja: "投票金額",
        kr: "베팅 금액",
      };
      return labelMap[lang] || labelMap.zh;
    },
    orderTimeLabel() {
      return this.$t("reservation.order_time");
    },
    settleTimeLabel() {
      return this.$t("reservation.settle_time");
    },
    records() {
      const rows = Array.isArray(this.list) ? this.list : Object.values(this.list || {});
      if (!this.currentLotteryId) {
        return rows;
      }
      return rows.filter((item) => String(item.lottery?.id || "") === String(this.currentLotteryId));
    },
    typeNameMap() {
      const lang = this.$t("auth.lang");
      const map = {
        zh: { big: "玫瑰", small: "百合", one: "烟花", two: "气球" },
        en: { big: "Rose", small: "Lily", one: "Fireworks", two: "Balloon" },
        ja: { big: "バラは", small: "リリー·リリー", one: "花火大会", two: "気球" },
        kr: { big: "장미", small: "백합", one: "불꽃놀이", two: "풍선" },
      };
      return map[lang] || map.zh;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    getLotteryName(item) {
      const lang = this.$t("auth.lang");
      const lottery = item.lottery || {};
      if (lang === "en") return lottery.name_es || lottery.name || "";
      if (lang === "ja") return lottery.name_ja || lottery.name || "";
      if (lang === "kr") return lottery.name_kr || lottery.name || "";
      return lottery.name || "";
    },
    getDisplayName(name) {
      return this.typeNameMap[name] || name;
    },
    formatBetTypes(item) {
      const values = Object.values(item.wan || {});
      return values.map((entry) => this.getDisplayName(entry.name)).join(",");
    },
    getUserGameList() {
      this.$http({
        method: "get",
        url: "user_get_game_list",
      }).then((res) => {
        if (res.code === 200) {
          this.list = Array.isArray(res.data) ? res.data : Object.values(res.data || {});
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
      return;
    }
    this.getUserGameList();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.lottery-record-page {
  min-height: 100%;
  background: #f7f7f7;
}

.nav-bar {
  background: #ffffff;
}

::v-deep .van-nav-bar__title {
  color: #1d1d1f;
  font-size: 38px;
  font-weight: 700;
}

.record-body {
  min-height: calc(100vh - 92px);
  padding: 24px 18px 40px;
}

.record-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.record-card {
  width: 100%;
  padding: 28px 24px 26px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.record-top {
  display: flex;
  align-items: center;
  gap: 22px;
  color: #141414;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.4;
}

.record-expect,
.record-name {
  font-size: 28px;
  font-weight: 700;
}

.record-types {
  margin-top: 16px;
  color: #1f1f1f;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.5;
  word-break: break-all;
}

.record-amount {
  margin-top: 18px;
  color: #ef5a7b;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.5;
}

.amount-value {
  margin-left: 8px;
}

.record-time {
  margin-top: 14px;
  color: #5f6368;
  font-size: 21px;
  font-weight: 500;
  line-height: 1.5;
}

::v-deep .van-empty {
  padding-top: 160px;
}

::v-deep .van-empty__description {
  color: #8b8b8b;
  font-size: 28px;
}
</style>
